// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zero_decision_lib-module__container--2aPDA{max-width:900px}.zero_decision_lib-module__main--2338V{display:inline}.zero_decision_lib-module__title--1aTGw{font-size:21px;line-height:30px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;margin-bottom:24px;padding-top:32px;color:#303030}\n", ""]);
// Exports
exports.locals = {
	"container": "zero_decision_lib-module__container--2aPDA",
	"main": "zero_decision_lib-module__main--2338V",
	"title": "zero_decision_lib-module__title--1aTGw"
};
module.exports = exports;
